export default __webpack_public_path__ + "static/media/4columns.5eaddacf.svg";